


















import Vue from 'vue'
import { mapGetters } from 'vuex'
export default Vue.extend({
    mounted() {
        this.$store.dispatch('loadTermsOfService')
    },
    computed: {
        ...mapGetters(['privacyPolicy', 'termsOfService', 'useAgreement']),
        buttons(): object {
            return [
                {
                    content: 'Terms of Service',
                    icon: 'mdi-paperclip',
                    text: this.termsOfService
                },
                {
                    content: 'Privacy Policy',
                    icon: 'mdi-paperclip',
                    text: this.privacyPolicy
                },
                {
                    content: 'Use Agreement',
                    icon: 'mdi-paperclip',
                    text: this.useAgreement
                }
            ]
        }
    },
    methods: {
        popDialog(btn: { content: string; text: string }): void {
            this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                title: btn.content,
                text: btn.text,
                icon: 'mdi-paperclip',
                closeable: true,
                scrollable: true
            })
        }
    }
})
